import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  specific_user_kyc_det: { status: "idle" },
};

export const specific_user_kyc_det_Slice = createSlice({
  name: "specific_user_kyc_det",
  initialState,
  reducers: {
    success_specific_user_kyc_det: (state, action) => {
      state.specific_user_kyc_det = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_specific_user_kyc_det: (state, action) => {
      state.specific_user_kyc_det = { status: app_consts.FAIL, message: action.payload };
    },
    reset_specific_user_kyc_det: (state) => {
      state.specific_user_kyc_det = { status: app_consts.IDLE };
    },
    loading_specific_user_kyc_det: (state) => {
      state.specific_user_kyc_det = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_specific_user_kyc_det,
  fail_specific_user_kyc_det,
  reset_specific_user_kyc_det,
  loading_specific_user_kyc_det,
} = specific_user_kyc_det_Slice.actions;

export default specific_user_kyc_det_Slice.reducer;
